import { Component, OnInit, HostBinding } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ElementDataRecordView, ElementService } from '../../service/element.service';
import {
	ConditionalTemplate,
	CTType,
	CTMultiSelectSetting,
	CTSelectSetting,
	CTRangeInputSetting,
	CTSilderSetting,
	SilderSetting
} from '../../service/recordview-param';

@Component({
	selector: 'common-conditional-template',
	templateUrl: './conditional-template.component.html',
	styleUrls: ['./conditional-template.component.scss']
})
export class ConditionalTemplateComponent implements OnInit {
	@HostBinding('class.conditional-template') hostClass = true;
	optionType = 'åºé´éæ©';
	optionIndicator = 'èç³»å°å';
	readonly Input = CTType.Input;
	readonly Select = CTType.Select;
	readonly Slider = CTType.Slider;
	readonly MultiSelect = CTType.MultiSelect;
	readonly RangeInput = CTType.RangeInput;
	public svr = this.elementSvr.data.recordview as ElementDataRecordView;
	constructor(public elementSvr: ElementService) {}

	ngOnInit() {}
	drop(event: CdkDragDrop<string[]>) {
		moveItemInArray(this.svr.Params.ConditionalTemplates, event.previousIndex, event.currentIndex);
	}
	addCondition() {
		this.svr.Params.ConditionalTemplates = this.svr.Params.ConditionalTemplates || [];
		const c = {
			Type: CTType.Input,
			Field: this.svr.Params.AllColumns.length > 0 ? this.svr.Params.AllColumns[0].Name : undefined,
			Setting: {}
		} as ConditionalTemplate;
		this.svr.Params.ConditionalTemplates.push(c);
		this.svr.currentConditionTemplate = c;
	}
	SelectCondition(data: ConditionalTemplate) {
		data.Setting = data.Setting || {};
		this.svr.currentConditionTemplate = data;
	}
	remove() {
		const idx = this.svr.Params.ConditionalTemplates.findIndex(v => v === this.svr.currentConditionTemplate);
		this.svr.Params.ConditionalTemplates.splice(idx, 1);
		if (this.svr.Params.ConditionalTemplates.length > 0) {
			this.svr.currentConditionTemplate = this.svr.Params.ConditionalTemplates[
				Math.min(idx, this.svr.Params.ConditionalTemplates.length - 1)
			];
		} else {
			this.svr.currentConditionTemplate = undefined;
		}
	}
	typeChange() {
		switch (this.svr.currentConditionTemplate.Type) {
			case CTType.Input:
				this.svr.currentConditionTemplate.Setting = {};
				break;
			case CTType.Select:
				this.svr.currentConditionTemplate.Setting = this.svr.currentConditionTemplate
					.Setting as CTSelectSetting;
				break;
			case CTType.MultiSelect:
				this.svr.currentConditionTemplate.Setting = this.svr.currentConditionTemplate
					.Setting as CTMultiSelectSetting;
				break;
			case CTType.RangeInput:
				this.svr.currentConditionTemplate.Setting = this.svr.currentConditionTemplate
					.Setting as CTRangeInputSetting;
				break;
			case CTType.Slider:
				this.svr.currentConditionTemplate.Setting = this.svr.currentConditionTemplate
					.Setting as CTSilderSetting;
				break;
		}
	}
	typeName(ty: CTType) {
		switch (ty) {
			case CTType.Input:
				return 'å½å¥';
			case CTType.Select:
				return 'åé';
			case CTType.MultiSelect:
				return 'å¤é';
			case CTType.RangeInput:
				return 'èå´å½å¥';
			case CTType.Slider:
				return 'èå´éæ©';
		}
	}
}
